import API from "./api";

export const getPublicClients = async () => {
  const response = await API.get("/clients");
  return response.data?.data || [];
};

export const getAdminClients = async () => {
  const response = await API.get("/clients/super-admin");
  return response.data?.data || [];
};

export const createClient = async (clientData) => {
  const response = await API.post("/clients/super-admin", clientData);
  return response.data?.data;
};

export const updateClient = async (id, clientData) => {
  const response = await API.patch(`/clients/super-admin/${id}`, clientData);
  return response.data?.data;
};

export const updateClientStatus = async (id, isActive) => {
  const response = await API.patch(`/clients/super-admin/${id}/status`, {
    isActive,
  });
  return response.data?.data;
};
